<template>
  <footer class="l-footer relative">
      <div class="container">
        <div class="flex flex-wrap jc-sb">
          <div class="l-footer--logo">
            <img src="~@/assets/logo-f.png" alt="">
          </div>
          <div class="l-footer--contact flex ai-c jc-c">
            <div class="l-footer--contact_tel center">
              <img src="~@/assets/icon-phone.png">
              <a class="bold" href="tel:04-22061234">04-22061234</a>
            </div>
            <ul class="l-footer--contact_list relative">
              <li class="flex"><img src="~@/assets/icon-add.png"><p>台中市西區民權路228號7樓</p></li>
              <li class="flex"><img src="~@/assets/icon-fax.png"><p>04-22027303</p></li>
              <li class="flex"><img src="~@/assets/icon-mail.png"><a href="mailto:socialwork@ccf.org.tw">socialwork@ccf.org.tw</a></li>
              <li>© T.F.C.F. Designed by <a href="https://weya.com.tw" title="網頁設計" target="_blank">Weya</a>.</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
</template>

<script>

export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.l-footer {
  padding: 20px 0;
  background: #9ab4d8;
  color: #fff;
  z-index: 10;
  &--logo{
    width: 200px;
  }
  &--contact{
    &_tel{
      padding-right: 20px;
      img{
        width: 40px;
        margin-bottom: 10px;
      }
      a{
        display: block;
      }
    }
    &_list{
      padding-left: 25px;
      &:after{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 5px;
        background: url(~@/assets/dotted.png)center center/cover no-repeat;
        z-index: 2;
      }
      li{
        padding: 2.5px 0;
      }
      img{
        width: 25px;
        max-height: 22px;
        margin-right: 5px;
      }
    }
  }
  @include respond-to(md) {
    top: -70px;
      &--logo{
        width: 300px;
      }
  }
}

</style>
